/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { FC } from 'react'
import { AiGoalsStoryInput, AiStoryInput } from '../StoryAiTypes'
import {
  AudienceInput,
  ImportanceInput,
  ImpactInput,
  AdditionalRequestsInput,
  PurposeInput,
} from './AiInputs'

type Props = {
  aiInput: AiStoryInput | AiGoalsStoryInput
  handleFocusChange: (input: string) => void
  handleChange: (value: string, key: string) => void
}

export const StoryAiInput: FC<Props> = ({
  handleChange,
  handleFocusChange,
  aiInput,
}) => (
  <>
    <PurposeInput
      handleChange={handleChange}
      handleFocusChange={handleFocusChange}
      aiInput={aiInput}
    />
    <AudienceInput
      handleChange={handleChange}
      handleFocusChange={handleFocusChange}
      aiInput={aiInput}
    />
    <ImpactInput
      handleChange={handleChange}
      handleFocusChange={handleFocusChange}
      aiInput={aiInput}
    />
    <ImportanceInput
      handleChange={handleChange}
      handleFocusChange={handleFocusChange}
      aiInput={aiInput}
    />
    <AdditionalRequestsInput
      handleChange={handleChange}
      handleFocusChange={handleFocusChange}
      aiInput={aiInput}
    />
  </>
)
